import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/shared/utils/cn";

interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
  className?: string;
}

export function ErrorState({
  title = "Something went wrong",
  description = "We encountered an error while loading the content. Please try again.",
  onRetry,
  className,
}: ErrorStateProps) {
  return (
    <div className={cn("text-center py-12", className)} data-testid="error-state">
      <AlertTriangle className="mx-auto h-12 w-12 text-destructive mb-4" data-testid="error-state-icon" />
      <h3 className="text-lg font-semibold text-foreground mb-2" data-testid="error-state-title">
        {title}
      </h3>
      <p className="text-muted-foreground mb-6 max-w-sm mx-auto" data-testid="error-state-description">
        {description}
      </p>
      {onRetry && (
        <Button onClick={onRetry} variant="outline" data-testid="error-state-retry">
          Try Again
        </Button>
      )}
    </div>
  );
}
